import React from 'react';
import PropTypes from 'prop-types';
import SVG from 'react-inlinesvg';

import AiIconSearch from '../icons/ai-icon-search.svg';

const AiButtonSearch = ({
	action,
	isDisabled,
	title,
}) => (
	<button
		type="button"
		className="ignite-ai__button-search"
		onClick={() => action()}
		disabled={isDisabled}
		title={isDisabled ? '' : title}
	>
		<SVG
			src={AiIconSearch}
			className="ignite-ai__icon-search"
		/>
	</button>
);

export default AiButtonSearch;

AiButtonSearch.propTypes = {
	action: PropTypes.func.isRequired,
	isDisabled: PropTypes.bool,
	title: PropTypes.string.isRequired,
};

AiButtonSearch.defaultProps = {
	isDisabled: false,
};
